




























import Vue from 'vue';
import Component from 'vue-class-component';
import debounce from 'lodash/debounce';

@Component({
  name: 'SearchBar',
})
export default class SearchBar extends Vue {
  searchValue = '';

  debouncedSearch: Function;

  constructor() {
    super();

    this.debouncedSearch = debounce(() => {
      this.onSearch();
    }, 250);
  }

  onSearchValueChange(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    this.searchValue = target ? target.value : '';

    this.debouncedSearch(event);
  }

  onSearch() {
    this.$emit('search', this.searchValue);
  }
}
